export default __webpack_public_path__ + "static/media/measuring.0dc604c0.svg";